<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import saveTasks from './saveTasks/index.vue';
import com from '../../../../../comMapping.js';
export default {
	components: {
		saveTasks
	},
	data() {
		return {
			//新增弹框是否显示
			showTasks: false,
			//表格
			size: '',
			shaidiag: false,
			headData: JSON.parse(localStorage.getItem('TaskConfigurationheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('TaskConfigurationoutlist')) || [],
			pagination: getdata().pagination, //分页数据
			tableData: [],
			tablekey: 0,
			addlist: {},
			//排序字段
			order: '',
			//排序顺序
			sort: '',
			//下拉数据
			options: [],
			//筛选字段
			param: {
				status: com.lqdsrwStatus.map(item => item.code)
			}
		};
	},
	mounted() {},
	created() {
		this.initialization();
	},
	methods: {
		//初始化
		initialization() {
			let params = {};
			params.limit = this.pagination.pageSize;
			params.page = this.pagination.pageNum;
			params.sort = this.sort;
			params.order = this.order;
			params.param = this.param;
			this.$https.fetchPost('/schedule/query', params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//新增弹框
		addTasks() {
			this.$https.fetchGet('/schedule/getTaskList').then(res => {
				this.options = res.data.data;
				this.addlist = {};
				this.showTasks = true;
				this.$nextTick(() => {
					this.$refs.empty.empty();
				});
			});
		},
		//编辑
		edit(e) {
			this.$https.fetchGet('/schedule/getTaskList').then(res => {
				this.options = res.data.data;
				this.addlist = {
					id: e.id,
					value: e.description,
					input: e.cron,
					select: e.name
				};
				this.showTasks = true;
			});
		},
		//隐藏新增弹框
		showTasksClose(e) {
			this.showTasks = false;
		},
		//新增修改 0保存并启动 1保存 2返回
		showAddTasks(e, deta) {
			let vo = {};
			if (e == 2) {
				this.showTasks = false;
			} else {
				console.log(deta);
				console.log(this.options);
				this.options.forEach(v => {
					if (deta.select == v.name) {
						vo.cron = deta.input;
						vo.description = v.description;
						vo.implementation = v.implementation;
						vo.name = v.name;
					}
				});
				//通过id去判断 是新增还是修改
				if (!deta.id) {
					this.$https.fetchPost('/schedule/add', vo).then(res => {
						if (res.data.code == '200') {
							if (e == 0) {
								this.$https.fetchGet('/schedule/start?id=' + res.data.data).then(res1 => {
									if (res1.data.code != '200') {
										this.$message.error(res.data.message);
									} else {
										this.$message.success('保存成功！');
										this.initialization();
										this.showTasks = false;
									}
								});
							} else {
								this.$message.success('保存成功！');
								this.initialization();
								this.showTasks = false;
							}
						} else {
							this.$message.error(res.data.message);
						}
					});
				} else {
					vo.id = deta.id;
					this.$https.fetchPost('/schedule/update', vo).then(res => {
						if (res.data.code == '200') {
							if (e == 0) {
								this.$https.fetchGet('/schedule/start?id=' + vo.id).then(res1 => {
									if (res1.data.code != '200') {
										this.$message.error(res.data.message);
									} else {
										this.$message.success('修改成功！');
										this.initialization();
										this.showTasks = false;
									}
								});
							} else {
								this.$message.success('修改成功！');
								this.initialization();
								this.showTasks = false;
							}
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			}
		},
		//点击启动按钮
		StartingAScheduledTask(e) {
			if (!e) {
				if (this.$refs.tablebox.getSelectionval().length != 1) {
					this.$message.error('请选择一条数据进行操作！');
					return;
				}
				e = this.$refs.tablebox.getSelectionval()[0].id;
			}
			this.$showConfirm({
				message: '是否启动定时任务?',
				title: '标题'
			}).then(res => {
				if (res == 'confirm') {
					this.$https.fetchGet('/schedule/start?id=' + e).then(res1 => {
						if (res1.data.code == '200') {
							this.$message.success('启动成功');
							this.initialization();
						} else {
							this.$message.error(res.data.message);
						}
					});
				} else {
					return;
				}
			});
		},
		//点击暂停按钮
		PauseAScheduledTask(e) {
			if (!e) {
				if (this.$refs.tablebox.getSelectionval().length != 1) {
					this.$message.error('请选择一条数据进行操作！');
					return;
				}
				e = this.$refs.tablebox.getSelectionval()[0].id;
			}
			this.$showConfirm({
				message: '是否暂停定时任务?',
				title: '标题'
			}).then(res => {
				if (res == 'confirm') {
					this.$https.fetchGet('schedule/stop?id=' + e).then(res1 => {
						if (res1.data.code == '200') {
							this.$message.success('暂停成功');
							this.initialization();
						} else {
							this.$message.error(res.data.message);
						}
					});
				} else {
					return;
				}
			});
		},
		//表格体 排序
		sortchange(e) {
			if (e.order != null) {
				this.sort = e.order == 'ascending' ? 'ASC' : 'DESC';
				this.order = e.prop;
			} else {
				this.sort = '';
				this.order = '';
			}
			this.initialization();
		},
		//筛选
		forSearchScreeningBox(obj) {
			this.param = obj;
			this.initialization();
		},
		//分页
		currentChange(e) {
			this.pagination.pageNum = e;
			this.initialization();
		},
		//行数
		sizechange(e) {
			this.pagination.pageSize = e;
			this.initialization();
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('TaskConfigurationoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('TaskConfigurationheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
